import { TOOLTIP_VIEWPORT_MARGIN } from '~/constants/markings'

/**
 * Clamps fixed-position tooltip coords inside the viewport. Reads the
 * element's rendered size — callers position first, then clamp on nextTick.
 */
export function clampTooltipToViewport(
  el: HTMLElement,
  coords: { x: number, y: number },
  margin = TOOLTIP_VIEWPORT_MARGIN,
): { x: number, y: number } {
  const rect = el.getBoundingClientRect()
  const maxX = window.innerWidth - rect.width - margin
  const maxY = window.innerHeight - rect.height - margin
  return {
    x: Math.min(Math.max(coords.x, margin), Math.max(margin, maxX)),
    y: Math.min(Math.max(coords.y, margin), Math.max(margin, maxY)),
  }
}
